// Test IDs for the standalone content pages (FAQ, Blog, Testimonials,
// Services, International Shipping, Quality Grades).

export const FAQ_PAGE = {
  section: 'faq-page-section',
  item: (i) => `faq-item-${i}`,
  question: (i) => `faq-question-${i}`,
  answer: (i) => `faq-answer-${i}`,
};

export const BLOG_INDEX_PAGE = {
  section: 'blog-index-page-section',
  postCard: (slug) => `blog-post-card-${slug}`,
};

export const BLOG_POST_PAGE = {
  section: 'blog-post-page-section',
  notFound: 'blog-post-not-found',
};

export const TESTIMONIALS_PAGE = {
  section: 'testimonials-page-section',
  card: (i) => `testimonials-page-card-${i}`,
};

export const SERVICES_PAGE = {
  section: 'services-page-section',
};

export const SHIPPING_PAGE = {
  section: 'shipping-page-section',
};

export const QUALITY_PAGE = {
  section: 'quality-page-section',
};
